// extracted by mini-css-extract-plugin
export var listItemsExpert = "NewPricingCard-module--listItemsExpert--e1670";
export var listItemsPro = "NewPricingCard-module--listItemsPro--708d1";
export var listItemsSecureEd = "NewPricingCard-module--listItemsSecureEd--ed73d";
export var listItemsStart = "NewPricingCard-module--listItemsStart--a3e2b";
export var quoteText = "NewPricingCard-module--quoteText--ea75c";